import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { GraphDataForTimeInterval } from './GraphDataForTimeInterval'



export const GraphForPersonal=() =>{


 return (
    <>
  <MainDiv>
  <GraphDataForTimeInterval/>
   
   </MainDiv> 
    </>
    
  )

  
}